import React from "react";
import Dropzone from "react-dropzone";
import { Button, Icon } from "antd";

const thumbsContainer = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  marginTop: 16
};

const thumb = {
  display: "inline-flex",
  borderRadius: 2,
  border: "1px solid #eaeaea",
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  height: 100,
  padding: 4,
  boxSizing: "border-box"
};

const thumbInner = {
  display: "flex",
  minWidth: 0,
  overflow: "hidden"
};

const img = {
  display: "block",
  width: "auto",
  height: "100%"
};

class Attachments extends React.Component {
  componentWillUnmount() {
    const { values, name, index } = this.props;

    const attachment = Array.isArray(values.attachments[index].mediaLink)
      ? values.attachments[index].mediaLink
      : [values.attachments[index].mediaLink];

    attachment.forEach(file => URL.revokeObjectURL(file.preview));
  }

  onDrop = acceptedFiles => {
    const f = acceptedFiles.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file)
      })
    );

    this.props.setFieldValue(this.props.name, f);
  };

  render() {
    const { values, index } = this.props;
    const attachment = Array.isArray(values.attachments[index].mediaLink)
      ? values.attachments[index].mediaLink
      : [values.attachments[index].mediaLink];

    return (
      <div>
        <Dropzone
          onDrop={this.onDrop}
          disabledStyle={{ backgroundColor: "gray" }}
          style={{
            borderStyle: "solid",
            backgroundColor: "white"
          }}
        >
          {({ getRootProps, getInputProps }) => (
            <React.Fragment>
              <div {...getRootProps()}>
                <input {...getInputProps()} />
                <Button>
                  <Icon type="upload" /> Sube fotos o videos
                </Button>
              </div>
              <aside style={thumbsContainer}>
                {attachment.map((file, i) => {
                  return (
                    <React.Fragment>
                      <div style={thumb} key={i}>
                        <div style={thumbInner}>
                          <img src={file.preview || file} style={img} />
                        </div>
                      </div>

                      {(file.type === "video/mp4" ||
                        file.type === "video/ogg") && (
                        <video height="100" width="200" autoPlay>
                          <source src={file.preview} type="video/mp4" />
                          <source src={file.preview} type="video/ogg" />
                          Your browser does not support the video tag.
                        </video>
                      )}
                    </React.Fragment>
                  );
                })}
              </aside>
            </React.Fragment>
          )}
        </Dropzone>
      </div>
    );
  }
}

export default Attachments;
